import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "multiple-select",
  style: {"min-width":"220px","height":"max-content"},
  tabindex: "1"
}
const _hoisted_2 = { class: "h-10 rounded-lg bg-white px-3 py-2.5 border border-gray-lp-400 w-full flex" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between w-full" }
const _hoisted_4 = {
  key: 0,
  class: "w-full align-middle text-sm text-gray-lp-600",
  style: {"line-height":"100%"}
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row gap-2 items-center text-sm px-2 font-medium text-gray-lp-300 bg-gray-lp-2500"
}
const _hoisted_6 = {
  style: {"line-height":"100%"},
  class: "align-middle"
}
const _hoisted_7 = {
  key: 0,
  class: "rounded-lg bg-white px-4 py-2.5 border border-gray-lp-2100 w-full absolute top-full mt-2 overflow-auto z-70",
  style: {"max-height":"199px"}
}
const _hoisted_8 = { class: "overflow-hidden overflow-ellipsis whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "relative",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (!_ctx.modelValue.length)
            ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('chooseHub')), 1))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.modelValue.length) + " " + _toDisplayString(_ctx.$t('chooseSelected')), 1),
                _createVNode("button", {
                  id: "multiple-select-clear",
                  class: "flex",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
                }, [
                  _createVNode(_component_Icons, {
                    name: "close",
                    class: "text-gray-lp-600 w-4 h-4"
                  })
                ])
              ])),
          _createVNode(_component_Icons, {
            name: "chevron-down-new",
            class: ["text-gray-lp-600 w-4 h-4 transition-transform duration-75", [{'transform rotate-180': _ctx.isOpen}]]
          }, null, 8, ["class"])
        ])
      ]),
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createBlock("div", {
                id: `multiple-select-option-${option.label}`,
                key: index,
                class: "py-2 flex flex-row items-center gap-2.5 text-sm text-gray-lp-300 w-full cursor-pointer",
                style: {"height":"37px"},
                onClick: ($event: any) => (_ctx.onSelectHub(option))
              }, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.isOptionChecked(option),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_8, _toDisplayString(option.label), 1)
              ], 8, ["id", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.onBlur]
  ])
}